import React from 'react/cjs/react.production.min';

export class TermSelectorComponent extends React.Component {
  constructor() {
    super();

    this.state = {
      term: null
    };

    qs.pricing.onTermPreferenceChanged((term) => {
      this.updateState(term);
    });
  }

  async componentDidMount() {
    this.updateState(await qs.pricing.getTermPreference());
  }

  updateState(term) {
    this.setState({ term });
  }

  handleChange(e) {
    qs.pricing.setTermPreference(e.target.value);
  }

  render() {
    return (
      <div className="term-selector">
        <label htmlFor="term">Preferred Term</label>
        <select id="term" value={this.state.term || ''} onChange={this.handleChange}>
          <option value="12">1 Year</option>
          <option value="24">2 Years</option>
          <option value="36">3 Years</option>
        </select>
      </div>
    )
  }
}
